import { render, staticRenderFns } from "./FilePersistent.vue?vue&type=template&id=1edc4980&scoped=true&"
import script from "./FilePersistent.vue?vue&type=script&lang=js&"
export * from "./FilePersistent.vue?vue&type=script&lang=js&"
import style0 from "./FilePersistent.vue?vue&type=style&index=0&id=1edc4980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc4980",
  null
  
)

export default component.exports